/**
 * Web Style Import
 *
 */

import './style/dnb-blockquote.scss'
